<!-- 
Dialog for seeding sample invoice records.

This is a testing tool only and is not available in production.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-form ref="form">
      <v-card>
        <v-toolbar color="secondary" flat dark>
          <v-toolbar-title>Seed sample invoices</v-toolbar-title>
        </v-toolbar>
        <our-busy-indicator :show="processing"/>
        <v-card-text>
          <p>
            The SAP team have entered simulated payments against a set of invoices for us. Running this seeder will
            create matching invoice records in the 2019 HELP levy collection which we can then use to test our SAP reconciliation. The levy collection
            providers for the invoicing scenarios will be marked as favourites so you can find them.
          </p>
          <p>
            Before running this seeder, ensure that the 2019 HELP levy collection:
            <ul>
              <li>Has had in-scope providers imported;</li>
              <li>Has had levy calculation parameters imported; and</li>
              <li>Is at the <i>Invoicing</i> status.</li>
            </ul>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn :disabled="processing" flat @click="hide">Cancel</v-btn>
          <v-btn 
            :disabled="processing"
            flat color="primary" 
            @click="seed"
          >
            Seed
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import * as action from "@/store/system/action-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state() {
      return this.$store.state.system.invoiceSeeding;
    },
    processing() {
      return this.state.processing;
    }
  },
  methods: {
    async seed() {
      await this.$store.dispatch(action.SEED_SAMPLE_INVOICES);
      this.hide();
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
